export type HttpRequestMethod = 'HEAD' | 'GET' | 'POST';

export const HTTP_PREMIUM_METHODS: HttpRequestMethod[] = ['GET', 'POST'];

export function getAvailableHttpMethods(isFreeTariff: boolean | null, isEnglish: boolean): HttpRequestMethod[] {
    return isFreeTariff && !isEnglish ? ['HEAD'] : ['HEAD', 'GET', 'POST'];
}

export function getCurrentHttpMethod(watched?: string, itemMethod?: string): string {
    return watched || itemMethod || 'HEAD';
}
